<section class="consejo-directivo mb-3">
  <div class="row m-0 header justify-content-center">
    <h1 class="title">Afiliarse en Línea</h1>
  </div>
  <div class="row mt-3 mt-md-5 mx-3 mx-md-0">
    <div class="col-md-2 col-0"></div>
    <div class="col-12 col-md-8 justify-content-center">
      <h2>
        ¡Inica el proceso de afiliación rellenando el siguiente formulario!
      </h2>

      <!-- Formulario starts -->
      <app-form-contacto></app-form-contacto>
      <!-- Formulario ends -->

      <p class="muted my-5">
        *Tus datos estarán protegidos por nuestra política de uso de datos y
        solo se usarán para fines de contacto.
      </p>

      <div class="documents nosotros">
        <h2 class="mt-5">Documentos requeridos</h2>
        <ul class="list">
          <li>Solicitud de Ingreso</li>
          <li>Carta de recomendación</li>
          <li>Acta de nacimiento</li>
          <li>INE</li>
          <li>CURP</li>
          <li>RFC</li>
          <li>Comprobante de domicilio</li>
          <li>Título profesional</li>
          <li>Cédula profesional</li>
          <li>Fotografía tamaño infantil</li>
          <li>Currículum vitae</li>
          <li>Pago de derechos</li>
        </ul>
      </div>
    </div>
    <div class="col-md-2 col-0"></div>
  </div>
</section>
